<template>
  <div class="modal-cadastro-perfil">
    <v-dialog :value="show" @input="fechar" scrollable max-width="900">
      <v-card>
        <v-card-title>Novo Perfil</v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="form.perfil"
                  label="Nome Perfil"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="form.descricao"
                  label="Descrição Perfil"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-row v-if="form.id_perfil">
            <v-col cols="12" md="12" sm="12">
              <v-card>
                <v-card-title class="subtitle-1">Permissões</v-card-title>
                <v-card-text>
                  <v-treeview
                    dense
                    v-model="selection"
                    :items="permissoes"
                    selection-type="leaf"
                    selectable
                    open-all
                  ></v-treeview>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn class="primary" @click="salvarPerfil">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import {permissoes , newPermissions } from "./permissoes";

export default {
  name: "ModalCadastroPerfil",
  props: {
    editar: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selection: [],
      permissoes: [],
      form: {},
      valid: true,
      requiredRules: [v => !!v || "Este Campo é Obrigatório"]
    };
  },
  methods: {
    fechar() {
      this.$emit("fechar");
      this.form = {};
      this.selection = [];
      this.$refs.form.resetValidation();
    },
    salvarPerfil() {
      this.form.permissoesAtualizadas = this.selection;
      this.$emit("submit", this.form);
    },
    async getPermission(){
      this.permissoes = await newPermissions(permissoes)
    } 
  },
  mounted() {
    this.getPermission()
  },
  watch: {
    editar(newPerfil) {
      this.form = { ...newPerfil };
      Object.entries(newPerfil.permissoes).forEach(([key, value]) => {
        if (value === true) {
          this.selection.push(key);
        }
      });
    }
  }
};
</script>
